import axios from 'axios';
import {getIn, setIn, updateIn} from 'lib/immutableObject';
import {updatePropertyPreferences} from 'api/propertyPreferences';

const SELECT = 'propertyNotes/actions/SELECT';
export const UPDATE = 'propertyNotes/actions/UPDATE';
const UPDATE_MANY = 'propertyNotes/actions/UPDATE_MANY';

export const initialState = {};

const PropertyNotesDuck = (state = initialState, action) => {
  switch (action.type) {
    case SELECT:
      return setIn(state, [action.payload.propertyId, 'selected', action.payload.comparableType], action.payload.selected);

    case UPDATE:
      return updateIn(state, [action.payload.propertyId], (v) => ({
        ...v,
        note: `${action.payload.note || ''}`,
      }));

    case UPDATE_MANY:
      return Object.keys(action.payload).reduce((acc, propertyId) => {
        return setIn(acc, [propertyId, 'note'], `${action.payload[propertyId] || ''}`);
      }, state);

    default:
      return state;
  }
};

export default PropertyNotesDuck;

export const selectPropertyNotes = (propertyId, comparableType, selected, savePreference = false) => {
  return (dispatch, getState) => {
    if (savePreference) {
      const {
        propertyDetail: {propertyId: targetPropertyId},
        propertyNotes,
      } = getState();

      const selectedNotes = Object.keys(propertyNotes)
        .filter((id) => getIn(propertyNotes, [id, 'selected', comparableType]))
        .map((id) => parseInt(id, 10));

      updatePropertyPreferences(targetPropertyId, {
        [`propertyNotes.${comparableType}.selected`]: [...selectedNotes, propertyId],
      });
    }

    dispatch({
      type: SELECT,
      payload: {propertyId, comparableType, selected},
    });
  };
};

export const setPropertyNotes = (propertyId, note) => (dispatch) => {
  dispatch({
    type: UPDATE,
    payload: {propertyId, note},
  });
};

export const updatePropertyNotes = (propertyId, note) => (dispatch) => {
  dispatch({
    type: UPDATE,
    payload: {propertyId, note},
  });

  try {
    return axios.put(`/api/properties/${propertyId}/notes`, {note});
  } catch (err) {
    //ignore
  }
};

export const updateManyPropertyNotes = (notes) => {
  return {
    type: UPDATE_MANY,
    payload: notes,
  };
};
